<template>
    <div class="page">
        <!-- <div class="ui-panel"> -->
        <el-card class="card-box">
            <!-- <p class="ui-panel-title">我的直播</p> -->
            <div slot="header" class="clearfix">
                <span>{{$t('live.myLive')}}</span>
                <el-button v-if="isExist" type="primary" size="mini" plain round @click="deleteLiveRoom" style="float: right;">{{$t('live.deleteLive')}}</el-button>
            </div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="$i18n.locale==='zh-CN'?'120px':'200px'"
                     class="form-live">
                <el-form-item :label="$t('live.roomName')" prop="title">
                    <el-input v-model="ruleForm.title" :placeholder="$t('live.inputName')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('live.roomNotice')" prop="notice">
                    <el-input type="textarea" v-model="ruleForm.notice" :placeholder="$t('live.inputNotice')" :autosize="{ minRows: 2, maxRows: 4}" clearable></el-input>
                </el-form-item>

                <el-form-item :label="$t('c.startTime')" prop="timeValue">
                    <el-date-picker
                        v-model="ruleForm.timeValue"
                        type="datetimerange"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :range-separator="$t('c.to')"
                        :start-placeholder="$t('c.startTime')"
                        :end-placeholder="$t('c.endTime')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('live.isPassword')" prop="needPwd">
                    <el-radio-group v-model="ruleForm.needPwd">
                        <el-radio :label="true">{{$t('c.yes')}}</el-radio>
                        <el-radio :label="false">{{$t('c.no')}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item :label="$t('live.password')"  prop="pwd" v-if="ruleForm.needPwd">
                    <el-input :placeholder="$t('app.pwd')" v-model="ruleForm.pwd" show-password></el-input>
                </el-form-item>

                <div class="btn-group">
                    <el-button type="primary" round @click="putLiveRoom">{{$t('m.save')}}</el-button>
                    <el-button type="primary" :disabled="!isExist" plain round @click="getLiveRoomRtmp">{{$t('live.getAddress')}}</el-button>
                </div>
            </el-form>
        </el-card>

        <el-dialog :title="$t('live.liveInfo')"
                :visible.sync="dialogRtmp"
                width="550px"
                :close-on-click-modal="false"
                :modal-append-to-body="false">
            <el-form :model="dialogForm" ref="dialogForm"
                    class="live-dialog-form"
                    label-width="100px">
                <el-form-item :label="$t('live.rtmp')">
                    <el-input id="rtmp" v-model="dialogForm.rtmp"></el-input>
                    <el-button type="text" v-clipboard:copy="dialogForm.rtmp"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">{{$t('live.copy')}}</el-button>
                </el-form-item>
                <el-form-item :label="$t('live.liveCode')">
                    <el-input type="textarea" :rows="2" v-model="dialogForm.code"></el-input>
                    <el-button type="text" v-clipboard:copy="dialogForm.code"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">{{$t('live.copy')}}</el-button>
                </el-form-item>

            </el-form>
            <div class="live-tip">
                <p>{{$t('live.tip')}}: </p>
                <p>1. {{$t('live.tip1')}}</p>
                <p>2. {{$t('live.tip2')}}</p>
            </div>
            <div slot="footer" style="text-align: center;margin-top: -10px;">
                <el-button @click="dialogRtmp = false">{{$t('c.close')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
import api from '@/api';
    export default {
        components: {},
        data() {
            return {
                ruleForm: {
                    title: '',
                    notice: '',
                    timeValue:[],
                    // startTime: '',
                    // endTime: '',
                    needPwd: true,
                    pwd: ''
                },
                rules: {
                    title: [
                        {required: true, message: this.$t('live.inputName'), trigger: 'blur'},
                        {min: 2, max: 50, message: this.$t('rule.lengthBetween', ['2', '50']), trigger: 'blur'}
                    ],
                    notice: [
                        {max: 200, message: this.$t('rule.maxLength', ['200']), trigger: 'blur'}
                    ],
                    timeValue: [
                        {required: true, message: this.$t('live.startEndTime'), trigger: 'blur'}
                    ],
                    needPwd: [{required: true}],
                    pwd: [
                        {required: true, message: this.$t('app.pwd'), trigger: 'blur'},
                        {min: 2, max: 50, message: this.$t('rule.lengthBetween', ['2', '50']), trigger: 'blur'}
                    ],
                },
                dialogRtmp: false,
                dialogForm: {
                    rtmp: '',
                    code: ''
                },
                isExist: false
            }
        },
        computed: {},
        created() {
            this.getLiveRoom()
        },
        methods: {
            onCopy(e) {
                this.$message({
                    type: 'success',
                    message: this.$t('res.copySuccess')
                })
            },
            onError(e) {
                this.$message({
                    type: 'error',
                    message: this.$t('live.copyFail')
                })
            },

            // 更新房间信息
            putLiveRoom() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (!valid) return;
                    let data = {
                        title : this.ruleForm.title,
                        notice : this.ruleForm.notice,
                        startTime : this.ruleForm.timeValue[0],
                        endTime : this.ruleForm.timeValue[1],
                        needPwd : this.ruleForm.needPwd,
                        pwd : this.ruleForm.pwd
                    }
                    if(!data.needPwd){
                        delete data.pwd
                    }
                    api.putLiveRoom(data).then(res =>{
                        this.$message({
                            type: 'success',
                            message: this.$t('m.saveSuccess')
                        })
                        this.getLiveRoom()
                    })
                })
            },
            // 我的房间信息查询
            getLiveRoom(){
                api.getLiveRoom().then(res => {
                    let data = res.package
                    if(data){
                        this.ruleForm.timeValue = []
                        this.isExist = true
                        this.ruleForm.title = data.title
                        this.ruleForm.notice = data.notice
                        this.ruleForm.timeValue.push(data.startTime)
                        this.ruleForm.timeValue.push(data.endTime)
                        this.ruleForm.needPwd = data.needPwd
                        this.ruleForm.pwd = data.pwd ? data.pwd:''
                    }else{
                        this.isExist = false
                        this.ruleForm.title = ''
                        this.ruleForm.notice = ''
                        this.ruleForm.needPwd = true
                        this.ruleForm.pwd = ''
                        this.ruleForm.timeValue = []
                    }
                })
            },
            // 获取房间推流地址
            getLiveRoomRtmp(){
                this.dialogRtmp = true
                api.getLiveRoomRtmp().then(res =>{
                    let data = res.package
                    if(data){
                        this.dialogForm.rtmp = data.rtmp
                        this.dialogForm.code = data.code
                    }
                })
            },
            deleteLiveRoom(){
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    api.deleteLiveRoom().then(res =>{
                        this.$message({
                            type: 'success',
                            message: this.$t('m.delSuccess')
                        })
                        this.getLiveRoom()
                    })
                })
            }
        },
    }
</script>

<style scoped lang="scss">
.card-box{
    width: 680px;
    margin: 30px auto;
}
.form-live{
    padding-right: 40px;
}
.btn-group{
    text-align: center;
}
.live-dialog-form{
    margin-right: 40px;
}

.live-tip{
    margin: 0 40px 20px 40px;
    color: #9f9f9f;
    >p{
        line-height: 26px;
    }
}

</style>

